import { n as g } from "./Logger-CmiOOsKC.js";
import { Node as A } from "@babylonjs/core/node.js";
import { Bone as N } from "@babylonjs/core/Bones/bone.js";
import { LoadAssetContainerAsync as T } from "@babylonjs/core/Loading/sceneLoader.js";
import { Animation as y } from "@babylonjs/core/Animations/animation.js";
import "@babylonjs/loaders/glTF/index.js";
function d(t) {
  return t instanceof N ? t.getTransformNode?.() ?? null : t instanceof A ? t : null;
}
function k(t, i) {
  const a = d(t);
  return a !== null && i.has(a);
}
async function v(t, i, a) {
  let e;
  try {
    let c = t;
    const l = a.getAsset(t);
    l && (e = URL.createObjectURL(l), c = e);
    const o = t.split(".").pop()?.toLowerCase(), n = o ? `.${o}` : ".glb";
    return await T(c, i, { pluginExtension: n });
  } finally {
    e && URL.revokeObjectURL(e);
  }
}
var p = /* @__PURE__ */ new Map();
function x() {
  p.clear();
}
async function E(t, i, a) {
  if (p.has(t)) return p.get(t);
  try {
    const e = (await a.getOrLoadContainer(t, i)).animationGroups.map((c) => c.name);
    return p.set(t, e), e;
  } catch (e) {
    return g.warn(`[AnimationUtils] Failed to load clip names from ${t}: ${String(e)}`), [];
  }
}
function M(t) {
  const i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map();
  for (const o of t.targetedAnimations) {
    const n = o.animation, m = n.framePerSecond || 1, s = n.targetProperty, r = n.dataType;
    for (const f of n.getKeys()) {
      const u = f.frame / m;
      s === "position" && r === y.ANIMATIONTYPE_VECTOR3 ? i.set(u, f.value.clone()) : s === "rotationQuaternion" && r === y.ANIMATIONTYPE_QUATERNION ? a.set(u, f.value.clone()) : s === "scaling" && r === y.ANIMATIONTYPE_VECTOR3 && e.set(u, f.value.clone());
    }
  }
  const c = /* @__PURE__ */ new Set([
    ...i.keys(),
    ...a.keys(),
    ...e.keys()
  ]), l = [];
  for (const o of c) {
    const n = { time: o }, m = i.get(o);
    m && (n.position = [
      m.x,
      m.y,
      m.z
    ]);
    const s = a.get(o);
    s && (n.rotation = [
      s.x,
      s.y,
      s.z,
      s.w
    ]);
    const r = e.get(o);
    r && (n.scale = [
      r.x,
      r.y,
      r.z
    ]), l.push(n);
  }
  return l.sort((o, n) => o.time - n.time), l;
}
export {
  v as a,
  k as i,
  M as n,
  E as r,
  x as t
};

//# sourceMappingURL=AnimationUtils-Dau2PA8x.js.map